/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["*[_ngcontent-%COMP%]{margin:0;padding:0;color:#424650;font-size:14px;text-align:left;line-height:1.43}h1[_ngcontent-%COMP%]{font-weight:700;margin-bottom:14px;letter-spacing:.5px;text-transform:uppercase}ul[_ngcontent-%COMP%]{margin:10px 0;list-style-type:none}ul[_ngcontent-%COMP%]   svg-icon[_ngcontent-%COMP%]{width:14px;height:12px}button[_ngcontent-%COMP%]{display:block;margin-top:14px;padding:8px 16px}"];
export { styles as styles };
